import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";

function _attachPlugin() {
	const vuwFrame = this.useFrame && this.get("frame");
	
	const $editorContainer = $("<div/>").appendTo(
		this.useFrame ? vuwFrame.$box : this.$self.children(`.${this.boxClass}`)
	);
	
	// [initialize Quill]
	this.quill = new this.Quill($editorContainer.get(0), {
		modules: {
			toolbar: {
				container: this.config.toolbar,
				// override handlers
				handlers: this.pluginConfig.toolbar.handlers
			}
		},
		placeholder: this.placeholder || "",
		theme: this.theme
	});
	
	// add custom props.
	this.quill.vuwField = this;
	this.$editor = $(this.quill.root);
	
	// set toolbar icon's title.
	this.quill.getModule("toolbar").controls.forEach(control => {
		if(!this.pluginConfig.toolbar.titles[ control[0] ]) {
			return true;
		}
		
		const isButton = (control[1].tagName.toLowerCase() === "button");
		const elm = isButton ? control[1] : control[1].previousSibling;
		if(elm) {
			let ttl = this.pluginConfig.toolbar.titles[ control[0] ];
			if(u_.isObject(ttl) && elm.value) {
				ttl = ttl[elm.value];
			}
			u_.isString(ttl) && (elm.title = ttl);
		}
	});
	
	// add event listener.
	this.quill.on("text-change", (delta, oldDelta, source) => {
		// iframe使用の場合、サイズを更新する(async)
		this.useFrame && vuwFrame.updateSize();
		
		if(source === "user") {
			clearTimeout(this.quill._userTimer);
			this.quill._userTimer = setTimeout(() => {
				let val = this.quill.getContents();
				
				if(
					val.ops.length === 1 &&
					u_.isString(val.ops[0].insert) &&
					!val.ops[0].insert.replace(/\s$/, "")
				) {
					val = "";
				} else {
					val = JSON.stringify(val);
				}
				
				this.setVal(val, true);
			}, 400);
		}
	});
	
	// [for use frame]
	if(this.useFrame) {
		// * for jQuery - firefox bug *
		$editorContainer.get(0).offsetWidth;
		
		Object.assign(vuwFrame, {
			$editorContainer,
			$editor: this.$editor
		});
		
		if(this.theme === "snow") {
			vuwFrame.$toolbar = $(this.quill.getModule("toolbar").container);
			vuwFrame.$ghost = $("<div/>");
			
			$("<div/>").addClass("wysiwyg-ghost").css({
				"border-color": "transparent",
				"border-style": "solid",
				"border-width": $editorContainer.css("border-width") || [
					$editorContainer.css("border-top-width"),
					$editorContainer.css("border-right-width"),
					$editorContainer.css("border-bottom-width"),
					$editorContainer.css("border-left-width")
				].join(" "),
				"margin": $editorContainer.css("margin") || [
					$editorContainer.css("margin-top"),
					$editorContainer.css("margin-right"),
					$editorContainer.css("margin-bottom"),
					$editorContainer.css("margin-left")
				].join(" "),
				"padding": $editorContainer.css("padding") || [
					$editorContainer.css("padding-top"),
					$editorContainer.css("padding-right"),
					$editorContainer.css("padding-bottom"),
					$editorContainer.css("padding-left")
				].join(" ")
			}).append(vuwFrame.$ghost).appendTo(vuwFrame.$box);
		}
		
		vuwFrame.$self.width( Math.ceil( $editorContainer.outerWidth(true) ) );
	}
}

export default _attachPlugin;
